(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* Fit the existing text instead of hiding, truncating or rotating a message.
     Font fitting stops at 10px. Unusually long text remains horizontally
     scrollable, including with browser text enlargement. No content is dropped. */
  if (!customElements.get('domiq-announcement-strip')) {
    class DomIQAnnouncementStrip extends HTMLElement {
      connectedCallback() {
        // A theme-editor re-render can connect this element before its children.
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        this.track = this.querySelector('.domiq-announcement__track');
        if (!this.track) return;
        this.scheduleFit = this.scheduleFit || (() => {
          cancelAnimationFrame(this.fitFrame);
          this.fitFrame = requestAnimationFrame(() => this.fitText());
        });
        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.scheduleFit);
          this.resizeObserver.observe(this);
        }
        window.addEventListener('resize', this.scheduleFit);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        if (document.fonts) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.scheduleFit();
          });
          if (document.fonts.addEventListener) {
            document.fonts.addEventListener('loadingdone', this.scheduleFit);
          }
        }
        this.scheduleFit();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.fitFrame);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.scheduleFit);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (document.fonts && document.fonts.removeEventListener) {
          document.fonts.removeEventListener('loadingdone', this.scheduleFit);
        }
      }

      onBlockSelect(event) {
        const item = event.target.closest('.domiq-announcement__item');
        if (item) item.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }

      fitText() {
        if (!this.isConnected || !this.track || this.clientWidth === 0) return;
        const style = getComputedStyle(this);
        const maximum = parseFloat(style.getPropertyValue('--domiq-max-font')) || 14;
        const minimum = Math.min(maximum, parseFloat(style.getPropertyValue('--domiq-min-font')) || 10);
        this.style.setProperty('--domiq-fit-font', maximum);

        // Only mobile/tablet uses automatic font fitting; desktop keeps 14px.
        if (window.matchMedia('(max-width: 989px)').matches && this.track.getBoundingClientRect().width > this.clientWidth + 0.5) {
          let low = minimum;
          let high = maximum;
          this.style.setProperty('--domiq-fit-font', minimum);
          if (this.track.getBoundingClientRect().width <= this.clientWidth + 0.5) {
            // Bisection accounts for text, truck, gaps and separator together.
            for (let step = 0; step < 8; step += 1) {
              const middle = (low + high) / 2;
              this.style.setProperty('--domiq-fit-font', middle);
              if (this.track.getBoundingClientRect().width <= this.clientWidth + 0.5) low = middle;
              else high = middle;
            }
            this.style.setProperty('--domiq-fit-font', Math.floor(low * 100) / 100);
          }
        }

        // Overflow is a safety fallback for longer translations/text, not
        // the intended presentation of the user's two supplied messages.
        const overflowing = this.scrollWidth > this.clientWidth + 1;
        this.toggleAttribute('data-overflow', overflowing);
        if (overflowing) this.setAttribute('tabindex', '0');
        else this.removeAttribute('tabindex');
      }
    }
    customElements.define('domiq-announcement-strip', DomIQAnnouncementStrip);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
